<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="100px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher/>
                        </div>
                        <div class="inline-form-group">
                            <el-form-item label="Wydarzenie ukryte">
                                <el-switch v-model="form.hide"/>
                            </el-form-item>
                            <el-form-item label="Data ukryta">
                                <el-switch v-model="form.hide_date"/>
                            </el-form-item>
                        </div>
                        <el-form-item label="Typ wydarzenia"
                                      v-if="eventType === 'others'"
                                      :error="errors['event_type']"
                                      required>
                            <el-select v-model="form['event_type']"
                                       filterable
                                       placeholder="Typ wydarzenia"
                                       allow-create>
                                <el-option
                                        v-for="item in availableEventTypes"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="eventDetails.labels['name']"
                                      :error="errors[addLanguageSuffix('name')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('name')]"
                                      @blur="duplicateAnotherField($event.target.value, 'name_en')"/>
                        </el-form-item>
                        <el-form-item :label="eventDetails.labels['additional_name']"
                                      v-if="eventDetails.labels['additional_name']"
                                      :error="errors[addLanguageSuffix('additional_name')]">
                            <el-input v-model="form[addLanguageSuffix('additional_name')]"/>
                        </el-form-item>
                        <el-form-item label="Opis"
                                      :error="errors[addLanguageSuffix('description')]">
                            <wyswig-input v-model="form[addLanguageSuffix('description')]"/>
                        </el-form-item>
                        <el-form-item label="Tekst na kafelku"
                                      v-if="eventType !== 'music'"
                                      :error="errors[addLanguageSuffix('tile_text')]">
                            <el-input type="textarea"
                                      v-model="form[addLanguageSuffix('tile_text')]"/>
                        </el-form-item>
                        <edition-input v-model="form.edition"
                                       :errors="errors.edition"
                                       :required="true"/>
                        <el-form-item label="Popup">
                            <el-select v-model="form.popup"
                                       filterable
                                       clearable
                                       placeholder="Wybierz popup">
                                <el-option
                                        v-for="item in popups"
                                        :key="item.id"
                                        :label="item.working_name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Logotyp"
                                      v-if="eventType === 'theater' || eventType === 'others'"
                                      :error="errors['logotype']">
                            <image-input-component v-model="form.logotype"/>
                        </el-form-item>
                        <el-form-item label="Tagi"
                                      :error="errors['tags']">
                            <el-select v-model="form['tags']"
                                       class="fluid"
                                       filterable
                                       multiple
                                       default-first-option
                                       placeholder="Tagi"
                                       allow-create>
                                <el-option
                                        v-for="item in availableTags"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <EventOccurrences :errors="errors.occurrences"
                                          :occurrences.sync="form.occurrences">
                        </EventOccurrences>
                        <div>
                            <div class="box__header box__header--photos">
                                <span class="box__header--text">Zdjęcia:</span>
                            </div>
                            <photo-cropper :photo.sync="form.photo"
                                           :errors="errors"
                                           :croppers.sync="croppers"/>
                        </div>
                        <div>
                            <div class="box__header">
                                <span class="box__header--text">Widgety - widoczne w szczegółach:</span>
                            </div>
                            <widgets-input :widgets.sync="form.widgets"
                                           :errors="errors.widgets || []"/>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import PhotoCropper from '@/components/PhotoCropper'
    import WidgetsInput from '@/components/widgets/WidgetsInput'
    import EventOccurrences from '@/views/Events/EventOccurrences'
    import {Popup} from '@/api'
    import EditionInput from '@/components/EditionInput'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    occurrences: [],
                    widgets: [],
                    event_type: null
                },
                errors: {},
                availableEventTypes: [],
                availableTags: [],
                service: null,
                loadingPopups: false,
                popups: []
            }
        },
        mounted () {
            this.fetchData()
        },
        computed: {
            eventType () {
                return this.$route.meta.eventType
            },
            croppers: {
                set (updatedCroppers) {
                    updatedCroppers.forEach(cropper => {
                        this.$set(this.form, cropper.photoFieldName, cropper.img)
                        this.$set(this.form, cropper.paramsFieldName, cropper.params)
                    })
                },
                get () {
                    const croppers = [
                        {
                            id: 'square',
                            aspect: 188/156,
                            photoFieldName: 'square_photo',
                            paramsFieldName: 'square_crop_params',
                            label: 'Kadr kwadratowy'
                        },
                        {
                            id: 'horizontal',
                            aspect: 340/190,
                            photoFieldName: 'horizontal_photo',
                            paramsFieldName: 'horizontal_crop_params',
                            label: 'Kadr poziomy'
                        },
                        {
                            id: 'vertical',
                            aspect: 140/291,
                            photoFieldName: 'vertical_photo',
                            paramsFieldName: 'vertical_crop_params',
                            label: 'Kadr pionowy'
                        },
                    ]
                    const mergeFieldNameWithValues = cropper => {
                        return {
                            ...cropper,
                            img: this.form[cropper.photoFieldName],
                            params: this.form[cropper.paramsFieldName]
                        }
                    }
                    return croppers.map(mergeFieldNameWithValues)
                }
            }
        },
        components: {
            PhotoCropper,
            EventOccurrences,
            WidgetsInput,
            EditionInput
        },
        beforeMount () {
            this.service = this.eventDetails.service;
            this.redirectRoute = this.getRedirectRoute()
        },
        methods: {
            fetchData () {
                this.fetchPopups()
                this.$store.dispatch('fetchStages')
                this.$store.dispatch('fetchEditions')

                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                        this.form.tags = this.form.tags.map(tag => tag.name)
                    })
                } else {
                    this.form.event_type = this.eventType !== 'others' ? this.eventType : ''
                }

                this.service.tags().then(response => {
                    const listToObj = item => {
                        return {name: item.name, id: item.id}
                    }

                    this.availableTags = response.data.map(listToObj)
                })

                // fetch event types for 'others' events
                if (this.eventType === 'others') {
                    this.service.eventTypes().then(response => {
                        const listToObj = type => {
                            return {label: type, value: type}
                        }
                        this.availableEventTypes = response.data.map(listToObj)
                    })
                }
            },
            getRedirectRoute () {
                const type = this.eventType
                const routes = {
                    'theater': 'Spectacles List',
                    'music': 'Concerts List',
                    'others': 'OtherEvents List',
                    'cinema': 'Films List'
                }
                return {name: routes[type]}
            },
            fetchPopups () {
                Popup.all().then(response => {
                    this.popups = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const payload = {...this.form}
                const prepareTags = tag => typeof tag === 'string' ? {name: tag, event_type: this.eventType} : tag
                payload.tags = payload.tags.map(prepareTags)
                const service = id ? this.service.update(id, payload) : this.service.save(payload)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .box__header {
        &--photos {
            margin-top: 40px;
        }
    }
</style>



// WEBPACK FOOTER //
// EventForm.vue?c68f8ef2